import { Button, Link } from "@mui/material";
import React from "react";
import { useAppIdRouteParamListener } from "../../hook/app";
import {
  useFetchPageImplementationsListener,
  usePageImplementations,
  usePageImplementationsRoute,
} from "../../hook/implementation";
import {
  useFetchNotebookPageListener,
  useNotebookPagePath,
  useNotebookPageRouteParamListener,
  useSelectedNotebookPageIdMap,
} from "../../hook/page";
import { GoBackButton } from "../goBack";
import { NotePageContainer } from "../note";
import { ImplementationBlockImplementationById } from "./block/implementation";

export const NavigatePageImplementationsButton: React.FC = () => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  const route = usePageImplementationsRoute(selectedNotebookPageId);

  return (
    <Button component={Link} href={route} variant="outlined">
      Implementations
    </Button>
  );
};

export const NotebookPageImplementations: React.FC = () => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  useFetchPageImplementationsListener(selectedNotebookPageId);
  useAppIdRouteParamListener();
  useNotebookPageRouteParamListener();
  useFetchNotebookPageListener();
  const impls = usePageImplementations(selectedNotebookPageId);
  const pagePath = useNotebookPagePath();

  return (
    <>
      <GoBackButton href={pagePath({ pageId: selectedNotebookPageId })} />
      <NotePageContainer pageName="Implementations">
        {impls?.map((impl) => {
          return (
            <ImplementationBlockImplementationById
              key={impl["implementation-id"]}
              implementationId={impl["implementation-id"]}
            />
          );
        })}
      </NotePageContainer>
    </>
  );
};
